import { NAMESPACE } from 'react/api/actions/base';

const actions = {
  setTelematicsRangeIndex: `${NAMESPACE}_SET_TELEMATICS_RANGE_INDEX`,
  setTelematicsToggle: `${NAMESPACE}_SET_TELEMATICS_TOGGLE`
};

const actionCreators = {
  setTelematicsRangeIndex: ({ domain, id, capabilityName, rangeIndex }) => ({
    type: actions.setTelematicsRangeIndex,
    payload: { domain, id, capabilityName, rangeIndex }
  }),
  setTelematicsToggle: ({ domain, id, toggles }) => ({
    type: actions.setTelematicsToggle,
    payload: { domain, id, toggles }
  })
};

export default {
  actions,
  actionCreators
};
